"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMDestructuringBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../interfaces/vm-transformers/IVMScopeManager");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../node/NodeGuards");
const VMConstants_1 = require("../../VMConstants");
let VMDestructuringBytecodeCompiler = class VMDestructuringBytecodeCompiler {
    constructor(vmCompilerUtils, scopeManager) {
        this.vmCompilerUtils = vmCompilerUtils;
        this.scopeManager = scopeManager;
    }
    compileDestructuringPattern(pattern, context, consumeValue = false, isAssignment = false) {
        const previousMode = context._destructuringMode;
        context._destructuringMode = isAssignment ? 'assignment' : 'declaration';
        if (NodeGuards_1.NodeGuards.isArrayPatternNode(pattern)) {
            this.compileArrayPatternDestructuring(pattern, context);
        }
        else if (NodeGuards_1.NodeGuards.isObjectPatternNode(pattern)) {
            this.compileObjectPatternDestructuring(pattern, context);
        }
        context._destructuringMode = previousMode;
        if (consumeValue) {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.pop();
        }
    }
    compileArrayPatternDestructuring(pattern, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        let hasRestElement = false;
        for (let i = 0; i < pattern.elements.length; i++) {
            const element = pattern.elements[i];
            if (element === null) {
                continue;
            }
            if (NodeGuards_1.NodeGuards.isRestElementNode(element)) {
                hasRestElement = true;
                this.compileRestElementDestructuring(element, i, context);
            }
            else {
                builder.dup();
                builder.loadConst(i);
                builder.getComputed();
                this.compileDestructuringElement(element, context);
            }
        }
        if (!hasRestElement) {
            builder.pop();
        }
    }
    compileObjectPatternDestructuring(pattern, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const extractedKeys = [];
        for (const property of pattern.properties) {
            if (NodeGuards_1.NodeGuards.isRestElementNode(property)) {
                this.compileObjectRestElement(property, extractedKeys, context);
                continue;
            }
            if (NodeGuards_1.NodeGuards.isPropertyNode(property)) {
                const key = property.key;
                const value = property.value;
                if (NodeGuards_1.NodeGuards.isIdentifierNode(key) && !property.computed) {
                    extractedKeys.push(key.name);
                }
                builder.dup();
                if (NodeGuards_1.NodeGuards.isIdentifierNode(key) && !property.computed) {
                    const propIndex = context.constantPool.add(key.name);
                    builder.getPropertyByName(propIndex);
                }
                else {
                    (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(key);
                    builder.getComputed();
                }
                this.compileDestructuringElement(value, context);
            }
        }
        builder.pop();
    }
    compileDestructuringElement(element, context) {
        var _a, _b, _c, _d;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isIdentifierNode(element)) {
            const varName = element.name;
            const isAssignment = context._destructuringMode === 'assignment';
            if (isAssignment) {
                this.vmCompilerUtils.emitStoreVariable(varName, context);
            }
            else {
                const declarationKind = context._declarationKind || 'var';
                const isBlockScoped = declarationKind === 'let' || declarationKind === 'const';
                const isConst = declarationKind === 'const';
                const compilingFunctionParameters = context._compilingFunctionParameters === true;
                const isEnvVar = context.envVars.has(varName);
                if (isEnvVar) {
                    const nameIndex = context.constantPool.add(varName);
                    if (!context.localVariables.has(varName)) {
                        context.localVariables.set(varName, context.localVariables.size);
                    }
                    if (isBlockScoped) {
                        if (isConst) {
                            builder.storeToCurrentEnvConst(nameIndex);
                        }
                        else {
                            builder.storeToCurrentEnv(nameIndex);
                        }
                    }
                    else {
                        builder.storeToEnv(nameIndex);
                    }
                }
                else {
                    let localIndex;
                    let scopedKey;
                    if (isBlockScoped) {
                        scopedKey = (0, VMConstants_1.getScopedVariableName)(varName, context.blockScopeDepth);
                        localIndex = this.vmCompilerUtils.getNextLocalIndex(context);
                        context.variableScopes.set(scopedKey, { depth: context.blockScopeDepth, index: localIndex });
                        context.localVariables.set(scopedKey, localIndex);
                        (_a = context.activeBlockScopes) === null || _a === void 0 ? void 0 : _a.add(scopedKey);
                    }
                    else {
                        scopedKey = varName;
                        if (context.localVariables.has(scopedKey)) {
                            localIndex = context.localVariables.get(scopedKey);
                        }
                        else {
                            localIndex = context.localVariables.size;
                            context.localVariables.set(scopedKey, localIndex);
                        }
                    }
                    if (compilingFunctionParameters) {
                        if (!context.destructuredParameterNames) {
                            context.destructuredParameterNames = new Set();
                        }
                        context.destructuredParameterNames.add(scopedKey);
                    }
                    const actualLocalIndex = this.vmCompilerUtils.getActualLocalIndex(localIndex, context);
                    builder.storeLocal(actualLocalIndex);
                }
                this.scopeManager.exitLocalTDZ(context, varName);
            }
        }
        else if (NodeGuards_1.NodeGuards.isMemberExpressionNode(element)) {
            const memberExpr = element;
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(memberExpr.object);
            builder.swap();
            if (memberExpr.computed) {
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(memberExpr.property);
                builder.swap();
                builder.setComputed();
                builder.pop();
            }
            else {
                const propName = memberExpr.property.name;
                const propIndex = context.constantPool.add(propName);
                builder.setProperty(propIndex);
                builder.pop();
            }
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(element) || NodeGuards_1.NodeGuards.isObjectPatternNode(element)) {
            this.compileDestructuringPattern(element, context, false);
        }
        else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(element)) {
            const left = element.left;
            const defaultValue = element.right;
            builder.dup();
            builder.pushUndefined();
            builder.strictEqual();
            const skipDefault = builder.jumpIfFalse();
            builder.pop();
            (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(defaultValue);
            const jumpToAssign = builder.jump();
            skipDefault.patchToHere();
            jumpToAssign.patchToHere();
            this.compileDestructuringElement(left, context);
        }
    }
    compileRestElementDestructuring(restElement, startIndex, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const argument = restElement.argument;
        const tempIndex = context.localVariables.size;
        context.localVariables.set(`__array_temp_${startIndex}__`, tempIndex);
        const actualTempIndex = this.vmCompilerUtils.getActualLocalIndex(tempIndex, context);
        builder.storeLocal(actualTempIndex);
        builder.loadConst(startIndex);
        builder.loadLocal(actualTempIndex);
        builder.dup();
        builder.getProp('slice');
        builder.loadConst(1);
        builder.callMethod(1);
        this.compileDestructuringElement(argument, context);
    }
    compileObjectRestElement(restElement, extractedKeys, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const argument = restElement.argument;
        const tempObjIndex = context.localVariables.size;
        context.localVariables.set('__obj_rest_source__', tempObjIndex);
        const actualTempObjIndex = this.vmCompilerUtils.getActualLocalIndex(tempObjIndex, context);
        builder.storeLocal(actualTempObjIndex);
        builder.newObject();
        builder.loadLocal(actualTempObjIndex);
        builder.emitStaticMethodCall('Object', 'assign', 2);
        const copyObjIndex = context.localVariables.size;
        context.localVariables.set('__obj_rest_copy__', copyObjIndex);
        const actualCopyObjIndex = this.vmCompilerUtils.getActualLocalIndex(copyObjIndex, context);
        builder.storeLocal(actualCopyObjIndex);
        for (const key of extractedKeys) {
            builder.loadLocal(actualCopyObjIndex);
            builder.loadConst(key);
            builder.deleteProperty();
            builder.pop();
        }
        builder.loadLocal(actualCopyObjIndex);
        this.compileDestructuringElement(argument, context);
    }
};
exports.VMDestructuringBytecodeCompiler = VMDestructuringBytecodeCompiler;
exports.VMDestructuringBytecodeCompiler = VMDestructuringBytecodeCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object, typeof (_b = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _b : Object])
], VMDestructuringBytecodeCompiler);
